import { IBenefit, IBenefits } from '@dazn/lp-web/src/types/benefits.types';
import { IButton } from '@dazn/lp-web/src/types';
import { getImage } from '@dazn/lp-web/src/utils';
import { buttonProxy } from '@dazn/lp-web/src/proxies';

export function benefitsProxy(component: any): IBenefits {
    const title = component?.fields?.title;
    const componentType = component?.fields?.componentType;

    let button = {} as IButton;
    let benefits = [] as IBenefit[];
    component?.fields?.entries?.forEach(({ fields, sys }: any) => {
        if (sys?.contentType?.sys?.id === 'LPButton') {
            button = buttonProxy(fields);
        } else if (sys?.contentType?.sys?.id === 'LPContentItem') {
            benefits.push({
                title: fields.title,
                description: fields.description,
                logo: getImage(fields?.logo)
            });
        }
    });

    return {
        title,
        componentType,
        benefits,
        button
    };
}
